export default __webpack_public_path__ + "static/FoundersGrotesk-Light-be1d577a6b260d54832ec7753038feb6.ttf";